export default function Logo(): React.ReactElement {
  return (
    <svg width="98" height="29" viewBox="0 0 98 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>WEX</title>
      <path
        d="M0.5 17.8338V0.5H6.95079V17.8338C6.95079 20.8661 8.42451 21.9432 10.375 21.9432C12.3255 21.9432 13.7992 20.8661 13.7992 17.8338V0.5H20.25V17.8338C20.25 20.8661 21.7634 21.9432 23.6742 21.9432C25.5851 21.9432 27.0984 20.8661 27.0984 17.8338V0.5H33.5492V17.8338C33.5492 24.8154 29.4873 27.9274 24.2315 27.9274C21.086 27.9274 18.577 26.6903 17.024 24.3366C15.4711 26.6903 12.9621 27.9274 9.81652 27.9274C4.56192 27.9274 0.5 24.8154 0.5 17.8338Z"
        fill="black"
      />
      <path
        d="M63.4463 16.361C63.5593 15.645 63.6194 14.9122 63.6156 14.1649C63.5891 6.60206 57.4266 0.472427 49.8792 0.500093C42.3318 0.52655 36.2136 6.70196 36.2413 14.2636C36.2678 21.8252 42.4315 27.9549 49.9777 27.9273C55.5445 27.9084 60.3295 24.5411 62.4493 19.7435L54.9812 19.7701C53.6517 20.9842 51.8921 21.735 49.9548 21.7422C46.5715 21.7535 43.6962 19.5124 42.7461 16.4295L63.4463 16.361ZM49.9008 6.68266C52.9503 6.67132 55.5854 8.49233 56.772 11.1083L43.0608 11.1575C44.2282 8.53308 46.8513 6.6935 49.9008 6.68266Z"
        fill="black"
      />
      <path
        d="M89.813 0.5H81.4561L75.4833 9.28306L69.5104 0.5H61.1523L70.4773 14.2144L61.1523 27.9286H69.5104L75.4833 19.1455L81.4561 27.9286H89.813L80.4868 14.2144L89.813 0.5ZM68.7574 26.499H63.8499L72.2032 14.2144L63.8499 1.9284H68.7574L77.1107 14.213L68.7574 26.499Z"
        fill="black"
      />
      <path
        d="M68.0035 3.35742H66.5479L73.9295 14.2139L66.5479 25.0701H68.0035L75.3852 14.2139L68.0035 3.35742Z"
        fill="black"
      />
      <path d="M78.8355 14.2148V24.0736L75.4834 19.1436L78.8355 14.2148Z" fill="black" />
      <path d="M92.7933 1.09816H91.83V3.71412H91.0565V1.09816H90.1113V0.5H92.7933V1.09816Z" fill="black" />
      <path
        d="M94.1357 0.5L94.8515 2.73694L95.5649 0.5H96.5834V3.71412H95.8076V2.96324L95.8821 1.42666L95.1061 3.71412H94.5945L93.8163 1.42412L93.8907 2.96324V3.71412H93.1172V0.5H94.1357Z"
        fill="black"
      />
    </svg>
  )
}

try{ Logo.displayName ||= 'Logo' } catch {}